/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDocumentSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type DocumentSummary, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { ApprovalRequestBuilderRequestsMetadata, type ApprovalRequestBuilder } from './approval/index.js';
// @ts-ignore
import { AssociationRequestBuilderRequestsMetadata, type AssociationRequestBuilder } from './association/index.js';
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { ContentRequestBuilderRequestsMetadata, type ContentRequestBuilder } from './content/index.js';
// @ts-ignore
import { ReviewRequestBuilderRequestsMetadata, type ReviewRequestBuilder } from './review/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /documents/{id}
 */
export interface DocumentsItemRequestBuilder extends BaseRequestBuilder<DocumentsItemRequestBuilder> {
    /**
     * The approval property
     */
    get approval(): ApprovalRequestBuilder;
    /**
     * The association property
     */
    get association(): AssociationRequestBuilder;
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The content property
     */
    get content(): ContentRequestBuilder;
    /**
     * The review property
     */
    get review(): ReviewRequestBuilder;
    /**
     * DeleteDocument
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * GetDocument
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DocumentSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DocumentSummary | undefined>;
    /**
     * DeleteDocument
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * GetDocument
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DocumentsItemRequestBuilderUriTemplate = "{+baseurl}/documents/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DocumentsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof DocumentsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    approval: {
        requestsMetadata: ApprovalRequestBuilderRequestsMetadata,
    },
    association: {
        requestsMetadata: AssociationRequestBuilderRequestsMetadata,
    },
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    content: {
        requestsMetadata: ContentRequestBuilderRequestsMetadata,
    },
    review: {
        requestsMetadata: ReviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DocumentsItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: DocumentsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: DocumentsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDocumentSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
